"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../../makeStyles"));

var _Button = _interopRequireWildcard(require("../../Button"));

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

var _initial = _interopRequireDefault(require("lodash/initial"));

var _tokens = require("../../styles/tokens");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    breadcrumbs: {
      fontFamily: _tokens.fontFamilyDefault,
      fontSize: _tokens.fontSizeSmall
    }
  };
});
/**
 * Renders a breadcrumb element representing the current position in the hierarchy.
 */

var MasterDetailBreadcrumbs = function MasterDetailBreadcrumbs(props) {
  var selectedPath = props.selectedPath,
      rootTitle = props.rootTitle,
      onNodeSelect = props.onNodeSelect;
  var localClasses = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.default, {
    className: localClasses.breadcrumbs,
    maxItems: 3
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    key: "active",
    variant: "text",
    textVariantStyling: _Button.TEXT_STYLING_INHERIT,
    disabled: true
  }, rootTitle), (0, _initial.default)(selectedPath).map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: item.nodeId,
      variant: "text",
      textVariantStyling: _Button.TEXT_STYLING_INHERIT,
      onClick: function onClick(e) {
        return onNodeSelect(e, item);
      }
    }, item.label);
  })));
};

MasterDetailBreadcrumbs.propTypes = {
  selectedPath: _propTypes.default.array,
  rootTitle: _propTypes.default.string,
  onNodeSelect: _propTypes.default.func
};
var _default = MasterDetailBreadcrumbs;
exports.default = _default;